<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName" style="width: 110px;">配置名称：</label>
        <el-input class="input-box" placeholder="支付配置名称" v-model="queryParams.payConfigName" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button type="success" icon="el-icon-plus" @click="openDialog()">新建配置</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="payConfigName" label="配置名称" min-width="160" align="center"></el-table-column>
      <el-table-column prop="activeCode" label="激活码" min-width="160" align="center"></el-table-column>
      <el-table-column prop="notes" label="备注" min-width="160" align="center"></el-table-column>
      <el-table-column prop="opratorAccount" label="操作人" width="120" align="center"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center"></el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" plain @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" plain @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="form.id ? '编辑支付配置' : '新建支付配置'" :visible.sync="dialogVisible" width="520px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="配置名称">
          <el-input v-model="form.payConfigName" placeholder="支付配置名称" @keyup.enter.native="save()"></el-input>
        </el-form-item>
        <el-form-item label="激活码"><el-input v-model="form.activeCode" placeholder="收钱吧渠道激活码"></el-input></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.notes" placeholder="备注"></el-input></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10, payConfigName: '' },
      tableData: [],
      dialogVisible: false,
      form: {}
    }
  },
  created() { this.GetData() },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    GetData() {
      const loading = this.openLoading()
      post(215, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        payConfigName: (this.queryParams.payConfigName || '').trim()
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    openDialog(row) {
      this.form = row
        ? { id: row.id, payConfigName: row.payConfigName, activeCode: row.activeCode || '', notes: row.notes || '' }
        : { payConfigName: '', activeCode: '', notes: '' }
      this.dialogVisible = true
    },
    save() {
      const payConfigName = (this.form.payConfigName || '').trim()
      if (!payConfigName) {
        this.$message.error('配置名称不能为空')
        return
      }

      const isEdit = !!this.form.id
      const payload = {
        payConfigName,
        activeCode: (this.form.activeCode || '').trim(),
        notes: (this.form.notes || '').trim()
      }
      if (isEdit) payload.id = this.form.id

      const loading = this.openLoading()
      post(isEdit ? 213 : 212, payload).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(isEdit ? '修改成功' : '添加成功')
          this.dialogVisible = false
          this.GetData()
        } else {
          this.$message.error((isEdit ? '修改失败：' : '添加失败：') + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || (isEdit ? '修改失败' : '添加失败'))
      })
    },
    remove(row) {
      this.$confirm(`确认删除支付配置「${row.payConfigName}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(214, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.queryParams.pageIndex > 1) {
              this.queryParams.pageIndex -= 1
            }
            this.GetData()
          } else {
            this.$message.error('删除失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '删除失败')
        })
      }).catch(() => {})
    }
  }
}
</script>
